import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard, Users, ShieldCheck, FolderKanban, Handshake,
  ScrollText, Flag, LogOut, PanelLeftClose, Wallet,
  KeyRound, History, BadgePercent, Tags,
  ChartColumn, MessagesSquare, Megaphone
} from 'lucide-react'
import { clearSession } from '../lib/api'
import clsx from 'clsx'

const links = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/analytics', label: 'Аналитика', icon: ChartColumn },
  { to: '/users', label: 'Пользователи', icon: Users },
  { to: '/verification', label: 'Верификация', icon: ShieldCheck },
  { to: '/projects', label: 'Проекты', icon: FolderKanban },
  { to: '/proposals', label: 'Отклики', icon: FolderKanban },
  { to: '/deals', label: 'Выбор исполнителя', icon: Handshake },
  { to: '/chats', label: 'Чаты', icon: MessagesSquare },
  { to: '/payments', label: 'Продажи', icon: Wallet },
  { to: '/subscriptions', label: 'Подписки', icon: BadgePercent },
  { to: '/categories', label: 'Категории', icon: Tags },
  { to: '/promo', label: 'Промо / Push', icon: Megaphone },
  { to: '/reports', label: 'Жалобы', icon: Flag },
  { to: '/login-events', label: 'Входы', icon: History },
  { to: '/security', label: '2FA / Сессии', icon: KeyRound },
  { to: '/audit', label: 'Audit Log', icon: ScrollText },
]

export function Shell({
  children,
  collapsed,
  onToggle,
  userName,
}: {
  children: React.ReactNode
  collapsed: boolean
  onToggle: () => void
  userName?: string
}) {
  return (
    <div className={clsx('app-shell', collapsed && 'collapsed')}>
      <aside className="sidebar">
        <div className="brand">{collapsed ? 'N' : 'NaymA'}</div>
        {!collapsed && <div className="nav-group">Управление</div>}
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => clsx('nav-link', isActive && 'active')}>
            <Icon size={18} />
            {!collapsed && <span>{label}</span>}
          </NavLink>
        ))}
        <div style={{ flex: 1 }} />
        <button className="nav-link" style={{ background: 'transparent', border: 0, width: '100%', cursor: 'pointer' }} onClick={onToggle}>
          <PanelLeftClose size={18} />
          {!collapsed && <span>Свернуть</span>}
        </button>
        <button
          className="nav-link"
          style={{ background: 'transparent', border: 0, width: '100%', cursor: 'pointer' }}
          onClick={() => { clearSession(); window.location.href = '/login' }}
        >
          <LogOut size={18} />
          {!collapsed && <span>Выйти</span>}
        </button>
      </aside>
      <div className="main">
        <header className="topbar">
          <div>
            <strong>Админ-панель</strong>
            <div className="muted" style={{ fontSize: 12 }}>admin.nayma.ru</div>
          </div>
          <div className="muted">{userName || 'Сотрудник'}</div>
        </header>
        <main className="content">{children}</main>
      </div>
    </div>
  )
}
